export const ALL_SECTION_IDS = [
    'Executive Summary',
    'Platform Performance',
    'Competitor Analysis',
    'Top Performing Prompts',
    'Visibility Gaps',
    'Top Cited Sources',
    'Recommendations',
    'Raw Simulation Data',
];
//# sourceMappingURL=reports.js.map